import { customInstance } from '@/features/auth/axios-config'

import type {
  AddCompaniesRequest,
  AddCompaniesResponse,
  DeleteWorkflowDefinitionResponse,
  GetWorkflowDefinitionResponse,
  ListCompaniesRequest,
  ListCompaniesResponse,
  UpdateWorkflowDefinitionRequest,
  UpdateWorkflowDefinitionResponse,
} from './types'

const API_ENDPOINT_WORKFLOW = '/document/v1/workflows/definitions'
const buildApiById = (definitionId: string) =>
  `${API_ENDPOINT_WORKFLOW}/${definitionId}`

export const workflowConfigApi = {
  listCompanies: async (
    data: ListCompaniesRequest
  ): Promise<ListCompaniesResponse> => {
    return customInstance<ListCompaniesResponse>({
      method: 'post',
      url: `${API_ENDPOINT_WORKFLOW}/list`,
      data,
    })
  },

  getWorkflowDefinitionByCompany: async (
    workflowId: string
  ): Promise<GetWorkflowDefinitionResponse> => {
    return customInstance<GetWorkflowDefinitionResponse>({
      method: 'get',
      url: `${API_ENDPOINT_WORKFLOW}/${workflowId}`,
    })
  },

  /**
   * Add companies to workflow (auto-generates default reminders)
   * @param data - Request with company_ids array
   * @returns Promise with created workflow definitions
   */
  addCompaniesToWorkflow: async (
    data: AddCompaniesRequest
  ): Promise<AddCompaniesResponse> => {
    return customInstance<AddCompaniesResponse>({
      method: 'post',
      url: API_ENDPOINT_WORKFLOW,
      data,
    })
  },

  updateWorkflowDefinition: async (
    definitionId: string,
    data: UpdateWorkflowDefinitionRequest
  ): Promise<UpdateWorkflowDefinitionResponse> => {
    return customInstance<UpdateWorkflowDefinitionResponse>({
      method: 'put',
      url: buildApiById(definitionId),
      data,
    })
  },

  deleteWorkflowDefinition: async (
    definitionId: string
  ): Promise<DeleteWorkflowDefinitionResponse> => {
    return customInstance<DeleteWorkflowDefinitionResponse>({
      method: 'delete',
      url: buildApiById(definitionId),
    })
  },
}
